import { render, staticRenderFns } from "./CurrentAdvances.vue?vue&type=template&id=eebdc65a&"
import script from "./CurrentAdvances.vue?vue&type=script&lang=js&"
export * from "./CurrentAdvances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports